import { render } from "./BotonInstalacion.vue?vue&type=template&id=4c049949&scoped=true"
import script from "./BotonInstalacion.vue?vue&type=script&lang=js"
export * from "./BotonInstalacion.vue?vue&type=script&lang=js"

import "./BotonInstalacion.vue?vue&type=style&index=0&id=4c049949&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c049949"]])

export default __exports__